<template>
  <MainNavbar />
  <MainBanner />
  <AboutUs />
  <TeamMember />
  <OurTestimonial />
  <FAQ />
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import MainBanner from "../components/HomeThree/MainBanner.vue";
import AboutUs from "../components/HomeThree/AboutUs.vue";
import TeamMember from "../components/HomeThree/TeamMember.vue";
import OurTestimonial from "../components/HomeThree/OurTestimonial.vue";
import FAQ from "../components/HomeThree/FAQ.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";

export default defineComponent({
  name: "HomeThreePage",
  components: {
    MainNavbar,
    MainBanner,
    AboutUs,
    TeamMember,
    OurTestimonial,
    FAQ,
    MainFooter,
  },
});
</script>